import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  QuestionResponse2c5i2ax2qx74j as QuestionResponse,
  ID2laazuggebybv as ID,
  isComplete1mj6g5clu144t as isComplete,
  ID3b6wrkk3fpdmq as ID_0,
  ID__toString_impl_y5caka2oex5pjttokev as ID__toString_impl_y5caka,
  SurveyProgress2a3z8tdqg3ffh as SurveyProgress,
  Audience_Employers_getInstance2dlazlq0yh8zq as Audience_Employers_getInstance,
  nextTakingDate2z4ej6zmlzj64 as nextTakingDate,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import {
  surveyBody36qk50xkxc85p as surveyBody,
  answersToSubmit2mg7x325t3tua as answersToSubmit,
  get_language3mm5ndad9guf0 as get_language,
  textFor1swo8t3yupnka as textFor,
} from './surveyComponents.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  plus2m1vv33moko5t as plus,
  emptyMapr06gerzljqtm as emptyMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { HomePage3ptt6l367zajb as HomePage } from '../HomeScreen.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { maxWidth22r11xnm7d4h4 as maxWidth } from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_survey39c7m1qh20u4e as get_survey,
  get_takerId2o30vx45bol9y as get_takerId,
  get_takerIteration39isn1ebcp9sd as get_takerIteration,
  get_survey1jt3rdrcg0rh4 as get_survey_0,
  get_takerId1ugw8co5t0vwh as get_takerId_0,
  get_takerIteration1i7xba92wxwha as get_takerIteration_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { and3dbt2f202um49 as and } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _ID___init__impl__k1lb7eetc5oa5dx2ra as _ID___init__impl__k1lb7e,
  IDjecfjjw6mot9 as ID_1,
  _ID___init__impl__k1lb7e213aw7xpq3qqc as _ID___init__impl__k1lb7e_0,
  IDqqik72jjbpsn as ID_2,
  _ID___init__impl__k1lb7e1lquexfyufrn6 as _ID___init__impl__k1lb7e_1,
  ID1m87d1hextx54 as ID_3,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { shownWhen3t7othivfr11 as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_atEnd34105oxxaxc2o as get_atEnd } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SurveyTakePage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyCompletedText_anx46t_k$();
}
function SurveyTakePage$render$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyTakeAgainButton_c6h420_k$();
}
function SurveyTakePage$render$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.retaking_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function SurveyTakePage$render$lambda$lambda($next, $saved, this$0) {
  return ($this$swap) => {
    var destruct = $next;
    var survey = destruct.component1_7eebsc_k$();
    var translate = destruct.component2_7eebsb_k$();
    surveyBody($this$swap, survey, $saved, this$0.drafts_1, (it) => new (QuestionResponse())(VOID, this$0.id_1, it._id_1, survey.audience_1, this$0.takerId_1), translate);
    return Unit_instance;
  };
}
function SurveyTakePage$render$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyTakeSubmitButton_gkww0k_k$();
}
function SurveyTakePage$render$slambda_0($survey, $saved, this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $survey;
    var tmp = yield* await_0(this_1, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $saved;
    var tmp_0 = yield* await_0(this_2, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = this$0.drafts_1;
    var tmp$ret$3 = yield* await_1(this_3, $completion);
    var toSend = answersToSubmit(tmp, tmp_0, tmp$ret$3);
    var tmp_1;
    if (toSend.isEmpty_y1axqb_k$()) {
      var tmp_2 = $$this$button.get_context_h02k06_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_4 = get_strings(AppState_getInstance());
      var tmp$ret$4 = yield* await_1(this_4, $completion);
      toast(tmp_2, tmp$ret$4.get_surveyTakeNeedAnswerToast_561g7r_k$());
      return Unit_instance;
    }
    yield* session.get_questionResponses_1whaxp_k$().addAll_zaft0n_k$(toSend, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = $survey;
    var tmp_3 = yield* await_0(this_5, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = $saved;
    var tmp_4 = yield* await_0(this_6, $completion);
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(toSend, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var _iterator__ex2g4s = toSend.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$9 = new (ID())(element.question_1);
      destination.put_4fpzoq_k$(tmp$ret$9, element);
    }
    var nowComplete = isComplete(tmp_3, plus(tmp_4, destination));
    // Inline function 'kotlin.collections.mapOf' call
    var tmp$ret$10 = emptyMap();
    yield* this$0.drafts_1.set_revjhg_k$(tmp$ret$10, $completion);
    yield* this$0.retaking_1.set_revjhg_k$(false, $completion);
    yield* session.get_surveyProgresses_a5rnfi_k$().totallyInvalidate_d4stw5_k$($completion);
    var tmp_5;
    if (nowComplete) {
      var tmp_6 = $$this$button.get_context_h02k06_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_7 = get_strings(AppState_getInstance());
      var tmp$ret$11 = yield* await_1(this_7, $completion);
      toast(tmp_6, tmp$ret$11.get_surveyTakeThanksToast_6r9hqk_k$());
      get_pageNavigator($$this$button.get_context_h02k06_k$()).reset_diztr_k$(new (HomePage())());
      tmp_5 = Unit_instance;
    } else {
      var tmp_7 = $$this$button.get_context_h02k06_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_8 = get_strings(AppState_getInstance());
      var tmp$ret$12 = yield* await_1(this_8, $completion);
      toast(tmp_7, tmp$ret$12.get_surveyTakeSavedToast_evm8s6_k$());
      tmp_5 = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
function SurveyTakePage$render$lambda_2($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var SurveyTakePageClass;
function SurveyTakePage() {
  if (SurveyTakePageClass === VOID) {
    class $ {
      constructor(id, takerId) {
        this.id_1 = id;
        this.takerId_1 = takerId;
        var tmp = this;
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$0 = emptyMap();
        tmp.drafts_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0);
        this.retaking_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_surveys_tdixlc_k$().get_6ueaa7_k$(new (ID_0())(this.id_1)));
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
          return tmp1_elvis_lhs == null ? 'Survey' : tmp1_elvis_lhs;
        });
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        var survey = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_surveys_tdixlc_k$().get_6ueaa7_k$(new (ID_0())(this.id_1)));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Survey ' + ID__toString_impl_y5caka(this.id_1) + ' not found');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var latest = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_surveyProgresses_a5rnfi_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(SurveyProgress()), arrayOf([]), false));
          var tmp$ret$8 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$8);
          var tmp_1 = and(eq(get_survey(it), new (ID_0())(this.id_1)), eq(get_takerId(it), this.takerId_1));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(SurveyProgress()), arrayOf([]), false));
          var tmp$ret$15 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$15);
          this_0.descending_tl4o2_k$(get_takerIteration(it_0));
          var tmp$ret$11 = this_0.build_1k0s4u_k$();
          return firstOrNull($this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$11, VOID, 1))));
        });
        var completed = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(latest);
          if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.completedAt_1) == null)) {
            tmp = !$this$remember.invoke_r7m7el_k$(this.retaking_1);
          } else {
            tmp = false;
          }
          return tmp;
        });
        var saved = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(latest);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_0;
            if (tmp0_safe_receiver.completedAt_1 == null) {
              tmp_0 = tmp0_safe_receiver;
            } else {
              tmp_0 = null;
            }
            tmp = tmp_0;
          }
          var tmp1_elvis_lhs = tmp;
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.collections.mapOf' call
            return emptyMap();
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var taking = tmp_1;
          var tmp_2 = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_questionResponses_1whaxp_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(QuestionResponse()), arrayOf([]), false));
          var tmp$ret$22 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$22);
          var tmp$ret$20 = and(and(eq(get_survey_0(it), new (ID_0())(this.id_1)), eq(get_takerId_0(it), this.takerId_1)), eq(get_takerIteration_0(it), taking.takerIteration_1));
          // Inline function 'kotlin.collections.associateBy' call
          var this_0 = $this$remember.invoke_r7m7el_k$(tmp_2.query_so6xq1_k$(new (Query())(tmp$ret$20, VOID, VOID, 2147483647)));
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateByTo' call
          var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
          var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$27 = new (ID())(element.question_1);
            destination.put_4fpzoq_k$(tmp$ret$27, element);
          }
          return destination;
        });
        var takerName = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
          var tmp;
          switch ($this$remember.invoke_r7m7el_k$(survey).audience_1.ordinal_1) {
            case 1:
              var tmp1_safe_receiver = $this$remember.invoke_r7m7el_k$(session.get_families_is4v1x_k$().get_6ueaa7_k$(new (ID_1())(_ID___init__impl__k1lb7e(this.takerId_1))));
              tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_distinctName_5wyy9c_k$();
              break;
            case 2:
              var tmp2_safe_receiver = $this$remember.invoke_r7m7el_k$(session.get_employers_iw3lox_k$().get_6ueaa7_k$(new (ID_2())(_ID___init__impl__k1lb7e_0(this.takerId_1))));
              tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.name_1;
              break;
            case 3:
              var tmp3_safe_receiver = $this$remember.invoke_r7m7el_k$(session.get_careProviders_b5tc2w_k$().get_6ueaa7_k$(new (ID_3())(_ID___init__impl__k1lb7e_1(this.takerId_1))));
              tmp = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.name_1;
              break;
            case 0:
              tmp = null;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          var tmp4_elvis_lhs = tmp;
          return tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
        });
        var translate = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var employerName = $this$remember.invoke_r7m7el_k$(survey).audience_1.equals(Audience_Employers_getInstance()) ? $this$remember.invoke_r7m7el_k$(takerName) : null;
          return textFor($this$remember.invoke_r7m7el_k$(survey), get_language($this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance()))), employerName);
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
        element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(translate)($this$invoke.invoke_r7m7el_k$(survey).name_1));
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyAnsweringForLabel_wb231w_k$() + ' ' + $this$invoke.invoke_r7m7el_k$(takerName));
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_2 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(completed));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_2.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextView())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        var tmp_5 = KMutableProperty0();
        var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_3);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_3));
        element_3.invoke_bnq13k_k$(tmp_7, SurveyTakePage$render$lambda);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_3 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => {
          var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(latest);
          var completedAt = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.completedAt_1;
          var tmp;
          if (!(completedAt == null)) {
            var tmp1_safe_receiver = nextTakingDate($this$shownWhen.invoke_r7m7el_k$(survey), completedAt);
            var tmp_0;
            if (tmp1_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_0 = tmp1_safe_receiver.compareTo_e7gwgq_k$(today()) <= 0;
            }
            tmp = tmp_0 === true;
          } else {
            tmp = false;
          }
          return tmp;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_4 = themed(this_3, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Button())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_4.willAddChild_hz2iwc_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(element_4.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        element_4.willAddChild_hz2iwc_k$(element_5);
        var tmp_8 = KMutableProperty0();
        var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_10, SurveyTakePage$render$lambda_0);
        element_5.onStartup_vrxh3i_k$();
        element_4.addChild_2qpft2_k$(element_5);
        onClick(element_4, VOID, VOID, VOID, SurveyTakePage$render$slambda(this));
        element_4.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_4);
        element_2.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_5 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(completed));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (RowOrCol())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_5.willAddChild_hz2iwc_k$(element_6);
        element_6.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (SwapView())(element_6.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element_6.willAddChild_hz2iwc_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_6 = element_7;
        var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping = {_v: false};
        reactive(this_6, 8, ($this$reactive) => {
          var c = to($this$reactive.invoke_r7m7el_k$(survey), $this$reactive.invoke_r7m7el_k$(translate));
          queue.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.isEmpty_y1axqb_k$()) {
              break $l$loop;
            }
            var next = queue.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_0().Fade_1;
              this_6.swap_26x94b_k$(tmp_0, SurveyTakePage$render$lambda$lambda(next, saved, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        element_7.onStartup_vrxh3i_k$();
        element_6.addChild_2qpft2_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_7 = get_atEnd(element_6);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_8 = themed(this_7, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_9 = themed(this_8, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (Button())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_9.willAddChild_hz2iwc_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (TextView())(element_8.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_8.willAddChild_hz2iwc_k$(element_9);
        var tmp_11 = KMutableProperty0();
        var tmp_12 = TextView$_get_content_$ref_4pzcwl(element_9);
        var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(element_9));
        element_9.invoke_bnq13k_k$(tmp_13, SurveyTakePage$render$lambda_1);
        element_9.onStartup_vrxh3i_k$();
        element_8.addChild_2qpft2_k$(element_9);
        element_8.set_action_2ds022_k$(Action('Submit answers', VOID, VOID, VOID, VOID, VOID, SurveyTakePage$render$slambda_0(survey, saved, this, element_8)));
        element_8.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_8);
        element_6.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_10 = shownWhen(element, VOID, VOID, SurveyTakePage$render$lambda_2);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (Space())(this_10.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_10);
        this_10.willAddChild_hz2iwc_k$(element_10);
        element_10.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_10);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'SurveyTakePage', VOID, VOID, [Page()]);
    SurveyTakePageClass = $;
  }
  return SurveyTakePageClass;
}
//region block: exports
export {
  SurveyTakePage as SurveyTakePage3k2il0je8ciy,
};
//endregion

//# sourceMappingURL=SurveyTakePage.mjs.map
